import { memo } from 'react'
import { Flex, Text, useColorModeValue } from '@chakra-ui/react'
import { CATEGORIES_OBJECT } from 'constants/variables'

type Props = {
  category?: string
}

function AlertTypeCategoryCell({ category }: Props) {
  const { Icon, color, name } = CATEGORIES_OBJECT[category || '']

  const textColor = useColorModeValue(`${color}.500`, `${color}.200`)

  return (
    <Flex display="flex" alignItems="center" gap={2}>
      <Icon color={textColor} />
      <Text color={textColor}>{name}</Text>
    </Flex>
  )
}

export default memo(AlertTypeCategoryCell)
